var _a;
import { ActivityTemplateCode } from './activity-template.model';
export var ActivityTypePermissions = (_a = {},
    _a[ActivityTemplateCode.Other] = 'isHubActivityFormEnabled',
    _a);
